import { Progress } from 'antd';
import { GenericModal } from 'components/Modals/GenericModal';
import { Horizontal, StretchSpacer, Vertical } from 'gls';

function getPercentage(beaconCount: number, index: number) {
  return Math.min(Math.round(index / beaconCount * 100), 100);
}

type ImportActionModalProps = {
  totalCount: number,
  importedCount: number
}

export default function ImportProgress({ totalCount, importedCount }: ImportActionModalProps) {

  const percentage = getPercentage(totalCount, importedCount)

  return (
    <GenericModal isOpen hideCloseButton title="Importing Beacons" cancelName=''>
      <Vertical width={'100%'} spacing={10}>
        <Horizontal width={'100%'}>
          <span>{importedCount} Beacons</span>
          <StretchSpacer />
          <span>{percentage} %</span>
        </Horizontal>
        <Progress percent={percentage} showInfo={false} />
      </Vertical>
    </GenericModal>
  );
}
